/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react';
import { useQueryCacheAndNetwork } from '@/hooks/useQueryCacheAndNetwork';
import { QUERY_FETCH_SEARCH_UNIFIED } from '@edwin-group/people-graphql';
import { useAuthentication } from '@/hooks/useAuthentication';
import { SearchFilters } from '../utils/query-variables';

const DEFAULT_PAGE_SIZE = 12;

export const useUnifiedSearch = (filters: SearchFilters, page: number, shouldSkip: boolean) => {
  const { schoolContext } = useAuthentication();

  const variables = useMemo(
    () => ({
      searchTerm: filters.searchTerm || undefined,
      contentTypes: filters.contentTypes && filters.contentTypes.length > 0 ? filters.contentTypes : undefined,
      schoolContextDocumentId: schoolContext?.documentId ?? '',
      page,
      pageSize: DEFAULT_PAGE_SIZE,
    }),
    [filters, page, schoolContext?.documentId],
  );

  const { data, isInitialLoading, isRefetching, isUpdating } = useQueryCacheAndNetwork<any, any>(
    QUERY_FETCH_SEARCH_UNIFIED,
    {
      variables,
      skip: shouldSkip,
    },
  );

  const connection = data?.searchUnified;

  const isLoading = isInitialLoading || isRefetching || isUpdating;

  return {
    items: connection?.nodes ?? [],
    pageInfo: connection?.pageInfo ?? {
      page,
      pageSize: DEFAULT_PAGE_SIZE,
      pageCount: 1,
      total: 0,
    },
    isLoading,
  };
};
